import { BsCartCheck,
BsClockHistory,
BsFillCreditCardFill,} from "react-icons/bs";
import { FaShippingFast } from "react-icons/fa";

export const dataInfo = [
    {
        icon:<FaShippingFast /> ,
        heading:"Free Delivery",
        description:"We offer free delivery of meals",
    },
    {
        icon:<BsFillCreditCardFill />,
        heading:"Secure Payment",
        description:"Make secure payments for your meals",
    },
    // {
    //     icon:<BsCartCheck />,
    //     heading:"Quality Meals",
    //     description:"We sell and deliver quality meals"
    // },
    {
        icon: <BsClockHistory />,
        heading:"Open 24/7",
        description:"We are open 24 hrs everyday"
    }
]